import { MessageCircle } from 'lucide-react';
import { getWhatsAppLink } from '../data/mockData';

export const WhatsAppFab = () => {
  return (
    <a
      href={getWhatsAppLink()}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-fab"
      aria-label="Contactar por WhatsApp"
      data-testid="whatsapp-fab"
    >
      <MessageCircle className="w-6 h-6" />
    </a>
  );
};
